<span class="label" (click)="openChart(data.suggest)"
  >{{
    calorieCalculator.calculateSuggestions(
      data.suggest.foods,
      data.suggest.amount
    )
  }}
  کالری</span
>
<p class="title">پکیج پیشنهادی {{ data.title }}</p>

<div class="detail-list" *ngFor="let food of data.suggest.foods; let i = index">
  <div class="detail-title" *ngIf="!food.foodId?.recipe">
    {{ food.foodId.name }}
  </div>
  <div
    class="detail-title link-to-recipe"
    *ngIf="food.foodId?.recipe"
    (click)="goToRecipe(food.foodId.recipe)"
  >
    <img src="assets/tabBar/tab3Selected.png" alt="" />

    <span> {{ food.foodId.name }}</span>
  </div>
  <div class="description">
    {{ data.suggest.amount[i].amount }}
    {{ calorieCalculator.findSuggestionRatio(food).unitId.name }}
  </div>
</div>
<div class="center">
  <div
    class="change-package-button"
    (click)="
      changePackage(data.suggest.foods, data.suggest.amount, data.suggest.id)
    "
  >
    تعویض پکیج
  </div>
</div>
